module.exports = __webpack_public_path__ + "static/media/7.4f7be197.jpg";